import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sun px-5 py-20 sm:py-28" data-id="element-19" data-mp="pjzlbb82zkbs">
      <div className="mx-auto max-w-6xl" data-id="element-20" data-mp="pjg1foyvelv4">
        <div className="mx-auto max-w-2xl text-center" data-id="element-21" data-mp="avcwmiwkdg7w">
          <h2 className="font-display text-[1.75rem] font-black leading-tight tracking-tight text-ink sm:text-5xl" data-id="element-22" data-mp="auteb1304ptc">
            5 Practical Teacher Bonuses
          </h2>
          <p className="mt-4 font-display text-base font-bold text-ink sm:text-lg" data-id="element-23" data-mp="1tc1brkw548v">
            Included FREE With Your CAREER READY™ Pack
          </p>
        </div>

        <ol className="mt-12 flex flex-wrap justify-center gap-6" data-id="element-24" data-mp="3o1v50e6hlqom">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="relative flex w-full flex-col overflow-hidden rounded-2xl border-2 border-ink bg-white shadow-pop sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)]" data-id="element-25" data-mp="3t0g76j5aukfp" data-mpi={index}>
              <span className="absolute left-4 top-4 z-10 rounded-lg bg-ink px-2.5 py-1 font-display text-xs font-black uppercase tracking-wide text-sun" data-id="element-26" data-mp="1r9berkvjlfub">
                Bonus {index + 1}
              </span>
              <span className="absolute right-4 top-4 z-10 -rotate-6 rounded-lg border-2 border-ink bg-sun px-2.5 py-1 font-display text-xs font-black uppercase tracking-wide text-ink" data-id="element-27" data-mp="3dfld14naiu0w">
                FREE
              </span>
              <div className="flex aspect-[4/3] items-center justify-center bg-white" data-id="element-28" data-mp="3n67pwr3mh6fw">
                <img src={bonus.image} alt={`${bonus.title} bonus box`} className="h-full w-full object-contain p-2" loading="lazy" data-id="element-29" data-mp="2zeskgpgju90f" />
              </div>
              <div className="flex flex-1 flex-col border-t-2 border-ink px-6 py-5" data-id="element-30" data-mp="2uik63ea6ejub">
                <h3 className="font-display text-lg font-bold leading-snug text-ink" data-id="element-31" data-mp="38hjy8vwwdgv8">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-soft" data-id="element-32" data-mp="nprkf9d2crlo">
                  {bonus.lead}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}